<template>
    <console-layout width="100%" max-width="1280">
        <console-title>
            <span>상품목록</span>
        </console-title>

        <console-search @search="page=1; search(true)">
            <category-select v-model="filter._category" :categories="categories" @input="page = 1; search(true)" />
            <v-row>
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.isRecommend" :items="recommendItems" item-text="text" item-value="value" label="추천 상품" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                </v-col>
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.isMain" :items="mainItems" item-text="text" item-value="value" label="메인 상품" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                </v-col>
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details clearable :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                </v-col>
            </v-row>
        </console-search>

        <!-- <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-2 mx-1">
                <v-card-title class="tit tit--xs font-weight-bold">검색필터</v-card-title>
                <v-card-text class="pb-0">
                    <category-select v-model="filter._category" :categories="categories" @input="page = 1; search(true)" />
                    <v-row>
                        <v-col cols="12" sm="3">
                            <v-select v-model="filter.isRecommend" :items="recommendItems" item-text="text" item-value="value" label="추천 상품" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-select v-model="filter.isMain" :items="mainItems" item-text="text" item-value="value" label="메인 상품" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details clearable :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="page = 1; search(true)">
                        <v-icon small class="mt-1 mr-2">mdi-refresh</v-icon>초기화
                    </v-btn>
                    <v-btn color="primary" rounded text @click="page = 1; search(true)">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition> -->

        <console-body>
            <v-layout class="align-end">
                <span class="subtitle-2">검색수 : {{ summary.totalCount.format() }}</span>
                <v-spacer />
                <span>
                    <v-btn :disabled="!$hasScope(['root', 'admin'])" color="white" elevation="1" class="primary--text px-2 ml-1" @click="updateNaverShopping(true)">
                        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>전체상품업데이트
                    </v-btn>
                    <v-btn :disabled="!$hasScope(['root', 'admin'])" color="white" elevation="1" class="primary--text px-2 ml-1" @click="updateNaverShopping(false)">
                        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>요약상품업데이트
                    </v-btn>
                    <v-btn :disabled="!$hasScope(['root', 'admin'])" color="white" elevation="1" class="primary--text px-2 ml-1" @click="$refs.productRecomendUpdateDialog.open()">
                        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>추천상품변경
                    </v-btn>
                    <v-btn :disabled="!$hasScope(['root', 'admin'])" color="white" elevation="1" class="primary--text px-2 ml-1" @click="$refs.productMainUpdateDialog.open()">
                        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>메인상품변경
                    </v-btn>
                    <v-btn color="white" elevation="1" class="green--text px-2 ml-1" @click="excel">
                        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>엑셀다운로드
                    </v-btn>
                </span>
            </v-layout>
        </console-body>

        <!-- <v-row class="mt-4 px-1" align="end">
            <v-col cols="auto" class="tit tit--xs">검색수 : {{ summary.totalCount.format() }}</v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="white" class="primary--text px-2 ml-1" @click="updateNaverShopping(true)">
                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>전체상품업데이트
                </v-btn>
                <v-btn color="white" class="primary--text px-2 ml-1" @click="updateNaverShopping(false)">
                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>요약상품업데이트
                </v-btn>
                <v-btn color="white" class="primary--text px-2 ml-1" @click="$refs.productRecomendUpdateDialog.open()">
                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>추천상품변경
                </v-btn>
                <v-btn color="white" class="primary--text px-2 ml-1" @click="$refs.productMainUpdateDialog.open()">
                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>메인상품변경
                </v-btn>
                <v-btn color="white" class="green--text px-2 ml-1" @click="excel">
                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row> -->

        <v-data-table v-model="selected" :items="products" item-key="_id" :headers="productsHeaders" hide-default-footer disable-sort disable-pagination show-select class="mt-2 mx-1 elevation-1">
            <v-img slot="item.thumb" slot-scope="{item}" :src="item.thumb" max-width="96" height="96" contain class="ma-auto"/>
            <span slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
            <span slot="item.actions" slot-scope="{item}">
                <v-icon small class="mx-1" @click="edit(item)">mdi-pencil</v-icon>
                <v-icon v-if="$hasScope(['root', 'admin'])" small class="mx-1" @click="remove(item)">mdi-delete</v-icon>
            </span>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)"/>

        <v-btn v-if="$hasScope(['root', 'admin'])" fab fixed bottom right color="accent" @click="create"><v-icon>mdi-pencil</v-icon></v-btn>

        <excel-dialog ref="excelDialog" />
        <product-recomend-update-dialog ref="productRecomendUpdateDialog" v-on="{ updateRecomendProduct }"/>
        <product-main-update-dialog ref="productMainUpdateDialog" v-on="{ updateMainProduct }"/>

    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import ExcelDialog from "@/components/console/shop/products/excel-dialog.vue";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import CategorySelect from "@/components/console/shop/categories/category-select.vue";
import productMainUpdateDialog from '@/components/console/shop/products/product-main-update-dialog.vue';
import productRecomendUpdateDialog from '@/components/console/shop/products/product-recomend-update-dialog.vue';
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        ConsoleContent,
        CategorySelect,
        ExcelDialog,
        productMainUpdateDialog,
        productRecomendUpdateDialog
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                type: "main",

                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                isRecommend: this.$route.query.isRecommend || null,
                isMain: this.$route.query.isMain || null,

                _category: null,
            },

            categories: [],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            selected: [],
            summary: { totalCount: 0 },
            products: [],
            productsHeaders: [
                { text: "진열순서", value: "no", align: "center", width: 100  },
                { text: "상품코드", value: "code", align: "center", width: 150 },
                { text: "썸네일", value: "thumb", align: "center", width: 150 },
                { text: "상품이름", value: "name", align: "center", /* width: 10 */ },
                { text: "재고", value: "stock", align: "center", width: 100  },
                { text: "등록일자", value: "createdAt", align: "center", width: 180 },
                { text: "actions", value: "actions", align: "center", width: 100 },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "상품이름", value: "name" },
                { text: "상품코드", value: "code" },
                { text: "출판사", value: "publisher" },
            ],
            recommendItems: [
                { text: ":: 전체 ::", value: null },
                { text: "추천", value: "recommend" },
            ],
            mainItems: [
                { text: ":: 전체 ::", value: null },
                { text: "메인", value: "main" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            this.search(false);

            let { categories } = await api.console.shop.categories.gets({ params: { depth: 1 } });
            this.categories = categories;
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, products } = await api.console.shop.products.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.products = products;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        create(){
            this.$router.push(`/console/shop/products/create`);
        },
        edit(product){
            this.$router.push(`/console/shop/products/${product._id}`);
        },
        async remove(product){
            if(confirm("삭제하시겠습니까?")){
                await api.console.shop.products.delete(product);
                alert("삭제되었습니다");
                this.search(false);
            }
        },
        async updateNaverShopping(all = false){
            if(all){
                await api.plugins.naver.shopping.products();
                alert("전체 상품정보가 업데이트 되었습니다");
            }
            else {
                if(!this.selected.length) alert("업데이트 상품을 선택해주세요");
                else{
                    await api.plugins.naver.shopping.products({
                        params: {
                            _products: this.selected.map(product => product._id)
                        }
                    });
                    alert("요약 상품정보가 업데이트 되었습니다");
                }
            }
        },
        async updateRecomendProduct(isRecommend) {
            try {
                if (this.selected.length <= 0) throw new Error("상품을 선택해주세요")
                
                for(let i = 0; i < this.selected.length; i++) {
                    await api.console.shop.products.put({ ...this.selected[i], isRecommend })
                }

                alert("상품이 업데이트 되었습니다")
                this.selected = [];
                await this.init();
            } catch (error) {
                alert(error.message)
            }
        },
        async updateMainProduct(isMain) {
            try {
                if (this.selected.length <= 0) throw new Error("상품을 선택해주세요")
                
                for(let i = 0; i < this.selected.length; i++) {
                    await api.console.shop.products.put({ ...this.selected[i], isMain })
                }

                alert("상품이 업데이트 되었습니다")
                this.selected = [];
                await this.init();
            } catch (error) {
                alert(error.message)
            }
        },
        async excel(){
            this.$refs.excelDialog.open();
            this.$refs.excelDialog.$once("confirm", async (selected) => {
                let { products } = await api.console.shop.products.gets({ headers: { limit: 0 }, params: this.filter });

                let rows = [];
                products.forEach(product => {
                    let row = {};
                    for(let field of selected){
                        switch(field){
                            case "name": { row["상품이름"] = product[field]; break; }
                            case "code": { row["상품코드"] = product[field]; break; }
                            case "category": {
                                row["카테고리"] = product.categories?.reduce?.((categoryNames, category, index) => {
                                    let names = [];
                                    [...category._parents, category._id].reduce((categories, _id) => {
                                        let category = categories.find(category => category._id == _id);
                                        names.push(category?.name);
                                        return category?.children || [];
                                    },this.categories);
                                    return `${0 < index ? " , " : ''}${categoryNames + names.join('>')}`;
                                }, "");
                                break;
                            }
                            case "onDisplay": { row["상품진열"] = product[field] ? "진열" : "-"; break; }
                            case "soldout": { row["품절여부"] = product[field] ? "품절" : "-"; break; }
                            case "stock": { row["재고량"] = product[field]; break; }
                            case "costPrice": { row["소비자가(정가)"] = parseInt(product[field]).format(); break; }
                            case "salePrice": { row["판매가"] = parseInt(product[field]).format(); break; }
                            case "pointPercent": { row["포인트적립"] = `${product[field]}%`; break; }
                            case "optionalProducts": {
                                row["옵션"] = product?.optionalProducts?.reduce?.((optionalValues, optionalProduct, index) => {
                                    if(index == 0) optionalValues += `[${optionalProduct.optionalNames}]`;
                                    return optionalValues += `${0 < index ? " | " : ''}${optionalProduct.optionalValues.toString()}`;
                                }, "") || "-"; break;
                            }
                            case "images": { row["상품사진"] = product[field].join(","); break; }
                            case "writer": { row["작가"] = product[field]; break; }
                            case "publisher": { row["출판사"] = product[field]; break; }
                            case "isDeduction": { row["공제분류"] = product[field] ? "공제" : "미공제"; break; }
                            case "shippingCode": {
                                if(product[field] === "order") {
                                    row["배송정책"] = "기본정책"
                                }
                                if(product[field] === "free") {
                                    row["배송정책"] = "무료정책"
                                }
                                if(product[field] === "later") {
                                    row["배송정책"] = "착불정책"
                                }
                                if(product[field] === "self") {
                                    row["배송정책"] = "상품정책"
                                }
                                break;
                            }
                            case "publisher": { row["출판사"] = product[field]; break; }
                            default: { row[field] = product[field]; break;
                            }
                        }
                    }

                    rows.push(row);
                });

                let workbook = new XLSX.utils.book_new();
                let worksheet = XLSX.utils.json_to_sheet(rows);

                XLSX.utils.book_append_sheet(workbook, worksheet, "상품목록");
                XLSX.writeFile(workbook, "상품목록.xlsx");
            });
        }
    }
}
</script>